import React from 'react';
import { Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { WithRolesComponent } from 'HOC/withRoles';
import { pages } from './constants';

const AdminLinks = ({ navTo }) => {
  const location = useLocation();
  return (
    <WithRolesComponent allowedRoles={['ROLE_ADMIN']}>
      <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: '6px', flexShrink: 0 }}>
        {pages
          .filter((p) => p.allowedRoles.includes('ROLE_ADMIN'))
          .map((page) => {
            const isActive = location.pathname === page.to;
            return (
              <Button
                key={page.to}
                onClick={() => navTo(page.to)}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '13px',
                  px: '14px',
                  py: '8px',
                  borderRadius: '8px',
                  whiteSpace: 'nowrap',
                  color: isActive ? '#007BC6' : '#385576',
                  backgroundColor: isActive ? 'rgba(0, 123, 198, 0.12)' : 'transparent',
                  '&:hover': { backgroundColor: isActive ? 'rgba(0, 123, 198, 0.18)' : '#F0F4FA' },
                }}
              >
                {page.label}
              </Button>
            );
          })}
      </Box>
    </WithRolesComponent>
  );
};

export default AdminLinks;
